<template>
  <div class="container-exibicao" @click="$refs.input.focus()">
    <span class="exibicao">
      <b>{{ campo.name }}:</b>
      <input
        ref="input"
        type="text"
        placeholder="Digite"
        :value="text"
        @input="onInput"
      />
      <SettingAdvanced v-if="campo.advanced" :campo="campo" @update:advancedSetting="onUpdateAdvancedSetting" />
      <SVGIcon v-if="!campo.default" iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </span>
    <span ref="textSizer" class="text-sizer">{{ text }}</span>
  </div>
</template>
<script>
import SVGIcon from '../../SvgIcon.vue';
import SettingAdvanced from './SettingAdvanced.vue';
export default {
  props: {
    campo: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      required: true
    }
  },
  emits: ['update:text', 'aplicarFiltro'],
  components: {
    SVGIcon,
    SettingAdvanced
  },
  data() {
    return {
      debounceTimeout: null
    };
  },
  methods: {
    onExcluded() {
      this.$store.commit('removeFiltro', this.campo.filtro);
      this.$removeFiltroDaURL(this.campo.filtro, this.path);
      this.$store.commit('removeAdvancedSetting', this.campo.filtro);
      this.$filtroDb.removeFiltro(this.path, this.campo.filtro)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    onInput(event) {
      const value = event.target.value;
      this.$emit('update:text', value);
      this.adjustInputWidth();

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => this.$emit('aplicarFiltro'), 1000);
    },
    adjustInputWidth() {
      const input = this.$refs.input;
      const textSizer = this.$refs.textSizer;

      if (input && textSizer) {
        textSizer.textContent = input.value || this.placeholder;
        const width = textSizer.offsetWidth + 5;
        input.style.width = `${width}px`;
      }
    },
    async updateDbFiltros(value) {
      try {
        const filtros = await this.$filtroDb.recuperarFiltros(this.path);
        const filtroIndex = filtros.findIndex(filtro => filtro.filtro === this.campo.filtro);
        if(filtroIndex !== -1) {
          filtros[filtroIndex].advancedSetting = value;
          await this.$filtroDb.salvarFiltros(this.path, filtros);
        }
      } catch (error) {
        console.error(error, "ERRO AO ATUALIZAR FILTROS NO DB");
      }
    },
    onUpdateAdvancedSetting(value) {
      this.updateDbFiltros(value);
      if(this.text.length > 0) {
        this.$emit('aplicarFiltro');
      }
    }
  },
  mounted() {
    this.adjustInputWidth();
  },
  beforeUnmount() {
    clearTimeout(this.debounceTimeout);
  }
}
</script>
